import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCameraAuto: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCameraAuto"><Path d="M12 11.6957L13.1666 14.2981H10.8334L12 11.6957Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M7.09861 6L9.09861 3H14.9014L16.9014 6H22V21H2V6H7.09861ZM7.85193 17L10.9899 10H13.0101L16.1481 17H14.3778L13.8907 15.9135H10.1093L9.6222 17H7.85193Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCameraAuto;
